import * as Yup from 'yup';

const FilterSchema = Yup.object().shape({
  customer_email: Yup.string().nullable().email('Campo não é um e-mail válido'),
  customer_name: Yup.string().nullable().min(4, 'Insira pelo menos 4 caracteres'),
});

export default FilterSchema;
